var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3965 14.5745L17.425 0.603713C16.6209 -0.200912 15.3159 -0.200912 14.5107 0.603713L11.6095 3.50496L15.2899 7.18534C16.1451 6.89634 17.1259 7.09021 17.8076 7.77196C18.4926 8.45809 18.6851 9.44721 18.3891 10.3052L21.936 13.8522C22.7941 13.5566 23.7843 13.7478 24.4696 14.4343C25.4275 15.3918 25.4275 16.9437 24.4696 17.9018C23.5115 18.8601 21.9596 18.8601 21.001 17.9018C20.2805 17.1806 20.1025 16.1225 20.4673 15.2348L17.1595 11.9271L17.1591 20.6317C17.3989 20.7503 17.6179 20.9069 17.8076 21.0955C18.7655 22.053 18.7655 23.605 17.8076 24.5638C16.8495 25.5216 15.2969 25.5216 14.3401 24.5638C13.3823 23.605 13.3823 22.0531 14.3401 21.0956C14.5697 20.8659 14.8425 20.684 15.1427 20.5605V11.7747C14.842 11.652 14.5691 11.47 14.3401 11.2396C13.6144 10.5148 13.4399 9.44996 13.8118 8.55884L10.1838 4.93046L0.60375 14.5098C-0.20125 15.3152 -0.20125 16.6203 0.60375 17.4251L14.5755 31.3961C15.3799 32.2008 16.6846 32.2008 17.49 31.3961L31.3964 17.49C32.2011 16.685 32.2011 15.3791 31.3964 14.5745",
    fill: "#DE4C36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomGit);
export default __webpack_public_path__ + "static/media/custom_git.018cf14588be019c368d8ef1fd30b1d8.svg";
export { ForwardRef as ReactComponent };